import { render, staticRenderFns } from "./EFormTurma.vue?vue&type=template&id=799a2aa8&scoped=true"
import script from "./EFormTurma.vue?vue&type=script&lang=js"
export * from "./EFormTurma.vue?vue&type=script&lang=js"
import style0 from "./EFormTurma.vue?vue&type=style&index=0&id=799a2aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799a2aa8",
  null
  
)

export default component.exports